import axios from "axios";

const state = {
  installation: [],
  activeFilter: null,
  optimiserInstalled: false,
  canBypassOptimiser: false,
};

const getters = {
  installation: ({ installation }) => installation,
  activeFilter: ({ activeFilter }) => activeFilter,
  optimiserInstalled: ({ optimiserInstalled }) => optimiserInstalled,
  canBypassOptimiser: ({ canBypassOptimiser }) => canBypassOptimiser,
};

const actions = {
  async fetchInstallationOptions({ commit }) {
    return new Promise(async (resolve) => {
      const { data } = await axios.get(`/onsite-optimizer/onboarding/installation-instructions/`);
      commit('setInstallationMethods', data.installationInstructions);
      commit(
          'setActiveFilter',
          data.installationInstructions[0].value
      );
      resolve();
    });
  },
  async verifyInstallation({ commit }, websiteId) {
    return await (axios.get(`/onsite-optimizer/onboarding/website/${websiteId}/verify-installation`));
  },
  setActiveFilter: ({ commit }, filter) => {
    commit('setActiveFilter', filter);
  },
  async fetchSingleRandomTip() {
    return (await axios.get('/onsite-optimizer/random-tip')).data.data.tip;
  },
  async hideSplashPage() {
    return await axios.post('/onsite-optimizer/hide-splash');
  },
  async completedHelpVideo() {
    return await axios.post('/onsite-optimizer/complete-help-video');
  },
  async fetchOptimiserInstallationStatus({commit}) {
    return new Promise(async (resolve) => {
      const { data } = await axios.get('/onsite-optimizer/installation-status');

      commit('setOptimiserInstallationStatus', data.data.optimiser_installed);
      resolve();
    });
  },
  async fetchCanUserBypassOptimiserInstallation({commit}) {
    return new Promise(async (resolve) => {
      const { data } = await axios.get('/onsite-optimizer/can-bypass-optimiser-installation');

      commit('setCanBypassOptimiser', data.data.can_bypass_optimiser);
      resolve();
    });
  },
};

const mutations = {
  setInstallationMethods(state, data) {
    state.installation = data;
  },
  setActiveFilter(state, filter) {
    state.activeFilter = filter;
  },
  setOptimiserInstallationStatus(state, status) {
    state.optimiserInstalled = status;
  },
  setCanBypassOptimiser(state, status) {
    state.canBypassOptimiser = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

